"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyntaxChecker = exports.ConditionalGotoActivities = exports.Gotos = void 0;
var SharedTypes_1 = require("../entities/SharedTypes");
var CheckerHelper_1 = require("../helpers/CheckerHelper");
var EntitiesHelper_1 = require("../helpers/EntitiesHelper");
;
exports.Gotos = ['goto', 'xgoto', 'pgoto', 'igoto'];
exports.ConditionalGotoActivities = ['xgw', 'igw'];
var AllowedVersions = ['0.0.1'];
var SyntaxChecker = (function () {
    function SyntaxChecker(yaml) {
        this._yaml = yaml;
        this._nodeIdName = {};
        this._activityNodeIdName = {};
    }
    Object.defineProperty(SyntaxChecker.prototype, "nodeIds", {
        get: function () { var nodeIds = []; for (var id in this._nodeIdName)
            nodeIds.push(id); return nodeIds; },
        enumerable: false,
        configurable: true
    });
    SyntaxChecker.prototype.CheckNodeUnicity = function (name, activities) {
        this._activityNodeIdName[name] = {};
        var errPhrase = function (aName) { return 'Activity named "' + aName + '" must be renamed because is too similar or equal to '; };
        for (var aName in activities) {
            var aId = EntitiesHelper_1.EntHelper.GetIdFromName(aName);
            var dup = this._nodeIdName[aId];
            if (dup !== undefined) {
                if (aId == this._procId) {
                    return errPhrase(aName) + 'the process name ("' + this._procName + '")';
                }
                else {
                    return errPhrase(aName) + 'the activity named "' + dup + '"';
                }
            }
            this._nodeIdName[aId] = aName;
            this._activityNodeIdName[name][aId] = aName;
            if (activities[aName] !== null) {
                var subactivities = activities[aName]['activities'];
                if (subactivities !== undefined) {
                    var unicity = this.CheckNodeUnicity(aName, subactivities);
                    if (unicity !== true)
                        return unicity;
                }
            }
        }
        return true;
    };
    SyntaxChecker.prototype.CheckActivities = function (nodeName, activities) {
        if (activities !== undefined) {
            var firstActivity = void 0;
            var reachedActivities = [];
            for (var aName in activities) {
                if (firstActivity === undefined)
                    firstActivity = aName;
                var act = activities[aName];
                if (act === null)
                    continue;
                var activity = new ActivityChecker(act, aName);
                var actcheck = activity.CheckNode();
                if (actcheck !== true)
                    return actcheck;
                if (act.xgoto !== undefined) {
                    if (CheckerHelper_1.CheckerHelper.IsArrayOf(act.xgoto, 'object')) {
                        for (var _i = 0, _a = act.xgoto; _i < _a.length; _i++) {
                            var x = _a[_i];
                            var xgoto = new IXGotoChecker(x, aName);
                            var xgotocheck = xgoto.CheckNode();
                            if (xgotocheck !== true)
                                return xgotocheck;
                        }
                    }
                    else
                        return 'The field "xgoto" is not valid in activity "' + aName + '"';
                }
                if (act.igoto !== undefined) {
                    if (CheckerHelper_1.CheckerHelper.IsArrayOf(act.igoto, 'object')) {
                        for (var _b = 0, _c = act.igoto; _b < _c.length; _b++) {
                            var i = _c[_b];
                            var igoto = new IXGotoChecker(i, aName);
                            var igotocheck = igoto.CheckNode();
                            if (igotocheck !== true)
                                return igotocheck;
                        }
                    }
                    else
                        return 'The field "igoto" is not valid in activity "' + aName + '"';
                }
                if (act.goto !== undefined && exports.ConditionalGotoActivities.includes(act.type)) {
                    if (CheckerHelper_1.CheckerHelper.IsArrayOf(act.goto, 'object')) {
                        for (var _d = 0, _e = act.goto; _d < _e.length; _d++) {
                            var i = _e[_d];
                            var goto_2 = new IXGotoChecker(i, aName);
                            var gotocheck = goto_2.CheckNode();
                            if (gotocheck !== true)
                                return gotocheck;
                        }
                    }
                    else
                        return 'The field "goto" is not valid in activity "' + aName + '"';
                }
                if (act.activities !== undefined) {
                    var checkactivities = this.CheckActivities(aName, act.activities);
                    if (checkactivities !== true)
                        return checkactivities;
                }
                var goto = [];
                var gotoType = null;
                if (act.goto !== undefined) {
                    gotoType = 'goto';
                    if (typeof (act.goto) == 'string')
                        goto.push(act.goto);
                    else if (CheckerHelper_1.CheckerHelper.IsArrayOf(act.goto, 'string'))
                        goto = act.goto;
                    else if (exports.ConditionalGotoActivities.includes(act.type)) {
                        for (var _f = 0, _g = act.goto; _f < _g.length; _f++) {
                            var g = _g[_f];
                            var _goto = act.goto;
                            for (var x in _goto)
                                if (_goto[x].then !== undefined)
                                    goto.push(_goto[x].then);
                        }
                    }
                }
                else if (act.xgoto !== undefined) {
                    gotoType = 'xgoto';
                    for (var _h = 0, _j = act.xgoto; _h < _j.length; _h++) {
                        var g = _j[_h];
                        var xgoto = act.xgoto;
                        for (var x in xgoto)
                            if (xgoto[x].then !== undefined)
                                goto.push(xgoto[x].then);
                    }
                }
                else if (act.igoto !== undefined) {
                    gotoType = 'igoto';
                    for (var _k = 0, _l = act.igoto; _k < _l.length; _k++) {
                        var g = _l[_k];
                        var igoto = act.igoto;
                        for (var i in igoto)
                            goto.push(igoto[i].then);
                    }
                }
                else if (act.pgoto !== undefined) {
                    gotoType = 'pgoto';
                    goto = act.pgoto;
                }
                if (goto.length > 0) {
                    for (var _m = 0, goto_1 = goto; _m < goto_1.length; _m++) {
                        var g = goto_1[_m];
                        if (!reachedActivities.includes(g) && g != aName)
                            reachedActivities.push(g);
                        var gId = EntitiesHelper_1.EntHelper.GetIdFromName(g);
                        if (gId === this._procId || this._activityNodeIdName[nodeName][gId] === undefined) {
                            return 'The "' + gotoType + ' ' + g + '" in activity "' + aName + '" is not a valid destination';
                        }
                    }
                }
            }
            if (reachedActivities.length > 0)
                for (var aName in activities) {
                    if (aName != firstActivity) {
                        if (!reachedActivities.includes(aName))
                            return "Activity ".concat(aName, " is not reached by any other activities");
                    }
                }
        }
        return true;
    };
    SyntaxChecker.prototype.Check = function () {
        var root = new RootChecker(this._yaml);
        var rootcheck = root.CheckNode();
        if (rootcheck === true) {
            this._procName = root.name;
            this._procId = EntitiesHelper_1.EntHelper.GetIdFromName(root.name);
            this._nodeIdName[this._procId] = root.name;
            var activities = this._yaml['activities'];
            if (activities !== undefined) {
                var unicity = this.CheckNodeUnicity(root.name, activities);
                if (unicity !== true)
                    return unicity;
                var checkactivities = this.CheckActivities(root.name, activities);
                if (checkactivities !== true)
                    return checkactivities;
                return true;
            }
            else
                return true;
        }
        else
            return rootcheck;
    };
    return SyntaxChecker;
}());
exports.SyntaxChecker = SyntaxChecker;
var NodeChecker = (function () {
    function NodeChecker(node, name) {
        this._childnodes = {};
        this._inclusiveConstraints = {};
        this._exclusiveConstraints = {};
        this._mutexContraints = [];
        this._node = node;
        this._name = name;
    }
    NodeChecker.prototype.CheckNode = function () {
        for (var n in this._node) {
            if (this._childnodes[n] === undefined)
                return 'Child "' + n + '" not expected in node "' + this._name + '"';
            else if ((typeof (this._childnodes[n].type) == 'string' && typeof (this._node[n]) != this._childnodes[n].type)
                || typeof (this._childnodes[n].type) == 'object' && !this._childnodes[n].type.includes(typeof (this._node[n])))
                return 'Child "' + n + '" must be "' + this._childnodes[n].type + '" in node "' + this._name + '"';
            else if (this._childnodes[n].valueChecker !== undefined && !this._childnodes[n].valueChecker(this._node[n]))
                return 'Child "' + n + '" has an invalid value in node "' + this._name + '"';
            else if (this._childnodes[n].contextChecker !== undefined) {
                var context = this._childnodes[n].contextChecker(this._node);
                if (context !== true)
                    return context;
            }
            else if (this._exclusiveConstraints[n] !== undefined) {
                for (var i in this._exclusiveConstraints[n])
                    if (this._childnodes[i] !== undefined)
                        return 'Child "' + n + '" is not compatible with child "' + i + '" (see node "' + this._name + '")';
            }
            else if (this._inclusiveConstraints[n] !== undefined) {
                for (var i in this._inclusiveConstraints[n])
                    if (this._childnodes[i] === undefined)
                        return 'Child "' + n + '" requires the presence of child "' + i + '" (see node "' + this._name + '")';
            }
        }
        for (var n in this._childnodes) {
            if (this._childnodes[n].mandatory && this._node[n] === undefined)
                return 'Mandatory child "' + n + '" is not present in node "' + this._name + '"';
        }
        if (this._mutexContraints !== undefined) {
            for (var _i = 0, _a = this._mutexContraints; _i < _a.length; _i++) {
                var mutex = _a[_i];
                var counter = 0;
                for (var _b = 0, mutex_1 = mutex; _b < mutex_1.length; _b++) {
                    var c = mutex_1[_b];
                    if (this._node[c] !== undefined)
                        ++counter;
                    if (counter > 1)
                        return 'Child nodes "' + mutex.join(', ') + '" are mutually exclusive (see node "' + this._name + '")';
                }
            }
        }
        return true;
    };
    return NodeChecker;
}());
var RootChecker = (function (_super) {
    __extends(RootChecker, _super);
    function RootChecker(node) {
        var _this = _super.call(this, node, 'root') || this;
        _this._childnodes = {
            process: { type: 'string', mandatory: true },
            defaultType: { type: 'string', mandatory: false, valueChecker: function (val) { return SharedTypes_1.ActivityType.includes(val); } },
            activities: { type: 'object', mandatory: false }
        };
        return _this;
    }
    Object.defineProperty(RootChecker.prototype, "name", {
        get: function () {
            return this._node['process'];
        },
        enumerable: false,
        configurable: true
    });
    return RootChecker;
}(NodeChecker));
var ActivityChecker = (function (_super) {
    __extends(ActivityChecker, _super);
    function ActivityChecker(node, name) {
        var _this = _super.call(this, node, name) || this;
        _this._childnodes = {
            type: { type: 'string', mandatory: false, valueChecker: function (val) { return SharedTypes_1.ActivityType.includes(val); } },
            activities: { type: 'object', mandatory: false, contextChecker: function (node) { return node.type == 'sub' ? true : 'Child "activities" admitted only on root node or inside a "sub" activity (see node "' + _this._name + '")'; } },
            goto: { type: ['string', 'object'], mandatory: false,
                contextChecker: function (node) {
                    return typeof (node.goto) == 'string'
                        || ((node.type == 'pgw') && CheckerHelper_1.CheckerHelper.IsArrayOf(node.goto, 'string')) ? true : '"goto" field must be a single destination. Only in case of activity type "pgw" it can be a list of destinations (see node "' + _this._name + '")'
                        || (exports.ConditionalGotoActivities.includes(node.type) && CheckerHelper_1.CheckerHelper.IsArrayOf(node.goto, 'object') && node.goto.length > 1) ? true : '"goto" field must contain a list of {if, then} structure, with at least two elements, inside xgw or igw tasks (see node "' + _this._name + '")';
                },
                valueChecker: function (val) { return typeof (val) == 'string' || CheckerHelper_1.CheckerHelper.IsArrayOf(val, 'string') || (CheckerHelper_1.CheckerHelper.IsArrayOf(val, 'object') && val.length > 1); } },
            pgoto: { type: ['object'], mandatory: false, valueChecker: function (val) { return CheckerHelper_1.CheckerHelper.IsArrayOf(val, 'string') && val.length > 1; } },
            xgoto: { type: ['object'], mandatory: false, valueChecker: function (val) { return CheckerHelper_1.CheckerHelper.IsArrayOf(val, 'object') && val.length > 1; } },
            igoto: { type: ['object'], mandatory: false, valueChecker: function (val) { return CheckerHelper_1.CheckerHelper.IsArrayOf(val, 'object') && val.length > 1; } },
            condition: { type: 'string', mandatory: false, contextChecker: function (node) { return node.type == 'incond' ? true : 'Field "condition" is admitted only for "incond" activity type (see node "' + _this._name + '")'; } }
        };
        _this._mutexContraints.push(exports.Gotos);
        return _this;
    }
    ActivityChecker.prototype.HasGoto = function () {
        for (var n in this._node) {
            if (exports.Gotos.includes(n))
                return true;
        }
        return false;
    };
    Object.defineProperty(ActivityChecker.prototype, "xgotos", {
        get: function () {
            return this._node['xgoto'];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ActivityChecker.prototype, "igotos", {
        get: function () {
            return this._node['igoto'];
        },
        enumerable: false,
        configurable: true
    });
    return ActivityChecker;
}(NodeChecker));
var IXGotoChecker = (function (_super) {
    __extends(IXGotoChecker, _super);
    function IXGotoChecker(node, name) {
        var _this = _super.call(this, node, name) || this;
        _this._childnodes = {
            if: { type: ['string'], mandatory: true },
            then: { type: ['string'], mandatory: false }
        };
        return _this;
    }
    return IXGotoChecker;
}(NodeChecker));
//# sourceMappingURL=SyntaxChecker.js.map